module.exports = __webpack_public_path__ + "static/img/ershijiesizhong-xin.dd569106.jpg";